import { render, staticRenderFns } from "./ReviewTransferTransaction.vue?vue&type=template&id=d954bbe0"
import script from "./ReviewTransferTransaction.vue?vue&type=script&lang=js"
export * from "./ReviewTransferTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports